/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Strategy_Partner_Bitwise_Meta_DescriptionInputs */

const en_strategy_partner_bitwise_meta_description = /** @type {(inputs: Strategy_Partner_Bitwise_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automated Token Portfolios (ATPs) published by Bitwise, now on Glider.`)
};

const de_strategy_partner_bitwise_meta_description = /** @type {(inputs: Strategy_Partner_Bitwise_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktiv verwaltete Portfolios von Bitwise, jetzt auf Glider.`)
};

const pt_br2_strategy_partner_bitwise_meta_description = /** @type {(inputs: Strategy_Partner_Bitwise_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portfólios com gestão ativa da Bitwise, agora na Glider.`)
};

const tr_strategy_partner_bitwise_meta_description = /** @type {(inputs: Strategy_Partner_Bitwise_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitwise'ın aktif yönetilen portföyleri artık Glider'da.`)
};

const zh_cn2_strategy_partner_bitwise_meta_description = /** @type {(inputs: Strategy_Partner_Bitwise_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitwise 主动管理的投资组合，现已登陆 Glider。`)
};

const zh_hk2_strategy_partner_bitwise_meta_description = /** @type {(inputs: Strategy_Partner_Bitwise_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitwise 主動管理的投資組合，現已登陸 Glider。`)
};

const ko_kr2_strategy_partner_bitwise_meta_description = /** @type {(inputs: Strategy_Partner_Bitwise_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitwise가 액티브 운용하는 포트폴리오를 이제 Glider에서 만나보세요.`)
};

const ru_ru2_strategy_partner_bitwise_meta_description = /** @type {(inputs: Strategy_Partner_Bitwise_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Портфели под активным управлением Bitwise, теперь на Glider.`)
};

const es_419_strategy_partner_bitwise_meta_description = /** @type {(inputs: Strategy_Partner_Bitwise_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portafolios gestionados activamente por Bitwise, ahora en Glider.`)
};

/**
* | output |
* | --- |
* | "Automated Token Portfolios (ATPs) published by Bitwise, now on Glider." |
*
* @param {Strategy_Partner_Bitwise_Meta_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const strategy_partner_bitwise_meta_description = /** @type {((inputs?: Strategy_Partner_Bitwise_Meta_DescriptionInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Strategy_Partner_Bitwise_Meta_DescriptionInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_strategy_partner_bitwise_meta_description(inputs)
	if (locale === "de") return de_strategy_partner_bitwise_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_strategy_partner_bitwise_meta_description(inputs)
	if (locale === "tr") return tr_strategy_partner_bitwise_meta_description(inputs)
	if (locale === "zh-CN") return zh_cn2_strategy_partner_bitwise_meta_description(inputs)
	if (locale === "zh-HK") return zh_hk2_strategy_partner_bitwise_meta_description(inputs)
	if (locale === "ko-KR") return ko_kr2_strategy_partner_bitwise_meta_description(inputs)
	if (locale === "ru-RU") return ru_ru2_strategy_partner_bitwise_meta_description(inputs)
	return es_419_strategy_partner_bitwise_meta_description(inputs)
});